import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './MakeupArea.module.sass';
import Button from '../../../../ui_kit/button/Button';
import BackButton from '../../back_button/BackButton';
import Block from './block/Block';
import MAKEUP_CATEGORIES from '../../../constants/makeup_categories';

function MakeupArea(props) {
  const {
    increaseStep, decreaseStep, quiz, step,
  } = props;

  const [area, setArea] = useState(quiz.productType.split(' - ')[0]);
  const [customArea, setCustomArea] = useState(
    Object.values(MAKEUP_CATEGORIES).includes(
      quiz.productType.split(' - ')[0],
    ) ? '' : quiz.productType.split(' - ')[0],
  );
  const detailedProductType = quiz.productType.split(' - ').slice(1).join(' - ');

  const productType = `${area} - ${area === quiz.productType.split(' - ')[0] ? detailedProductType : ''}`;

  const onNextClick = () => {
    increaseStep({ ...quiz, productType });
  };

  const { color } = quiz;

  return (
    <>
      <BackButton
        decreaseStep={() => { decreaseStep({ ...quiz, productType }); }}
      />
      <div className={styles['makeup-area']}>
        <div className={styles.content}>
          {step}
          <div className={styles.title}>
            Which makeup category needs a makeover?
          </div>
          <div className={styles.description}>
            Select one.
          </div>
          <div className={styles.areas}>
            <Block
              text={MAKEUP_CATEGORIES.EYES}
              active={area === MAKEUP_CATEGORIES.EYES}
              onClick={() => { setArea(MAKEUP_CATEGORIES.EYES); }}
              color={color}
            />
            <Block
              text={MAKEUP_CATEGORIES.LIPS}
              active={area === MAKEUP_CATEGORIES.LIPS}
              onClick={() => { setArea(MAKEUP_CATEGORIES.LIPS); }}
              color={color}
            />
            <Block
              text={MAKEUP_CATEGORIES.FACE}
              active={area === MAKEUP_CATEGORIES.FACE}
              onClick={() => { setArea(MAKEUP_CATEGORIES.FACE); }}
              color={color}
            />
            <Block
              text={MAKEUP_CATEGORIES.NAILS}
              active={area === MAKEUP_CATEGORIES.NAILS}
              onClick={() => { setArea(MAKEUP_CATEGORIES.NAILS); }}
              color={color}
            />
            <Block
              text={customArea}
              active={
              (area && !Object.values(MAKEUP_CATEGORIES).includes(area))
              || area === MAKEUP_CATEGORIES.ACCESSORY
            }
              onClick={() => {
                setArea(customArea || MAKEUP_CATEGORIES.ACCESSORY);
              }}
              color={color}
              editable
              onInputChange={(event) => {
                const inputValue = event.target.value;
                setCustomArea(inputValue);
                setArea(inputValue || MAKEUP_CATEGORIES.ACCESSORY);
              }}
              inputPlaceholder={MAKEUP_CATEGORIES.ACCESSORY}
            />
          </div>
          <Button
            className={`${styles.button} custom-transparent-button`}
            onClickHandler={onNextClick}
            disabled={!area}
            text="NEXT"
            color="transparent-blue"
            size="small"
          />
        </div>
      </div>
    </>
  );
}

MakeupArea.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    productType: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
  step: PropTypes.node.isRequired,
};

export default MakeupArea;
